import { render, staticRenderFns } from "./CardSetAvailability.vue?vue&type=template&id=567cd780"
import script from "./CardSetAvailability.vue?vue&type=script&lang=js"
export * from "./CardSetAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports